// PlaybackContext.js
import { createContext, useContext, useState } from "react";

const PlaybackContext = createContext({
  isPlaying: true,
  setIsPlaying: () => {},
  currentTime: 0,
  setCurrentTime: () => {},
  notifications: [],
  setNotifications: () => {},
  selectedFeeds: [],
  setSelectedFeeds: () => {},
  duration: 0,
  setDuration: () => {},
  selectedValues: 0,
  setSelectedValues: () => {},
  layoutType: 1,
  setLayoutType: () => {},
  playbackRate: 1, // default 1x
  setPlaybackRate: () => {},
  sync: true,
  setSync: () => {},
});
export const usePlayback = () => useContext(PlaybackContext);

export const PlaybackProvider = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [notifications, setNotifications] = useState([]); // Example: [{ time: 120, message: 'Accident', type: 'accident' }]
  const [duration, setDuration] = useState(0);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [layoutType, setLayoutType] = useState(1);
  const [playbackRate, setPlaybackRate] = useState(1); // default 1x
  const [sync, setSync] = useState(true);
  return (
    <PlaybackContext.Provider
      value={{
        isPlaying,
        setIsPlaying,
        currentTime,
        setCurrentTime,
        notifications,
        setNotifications,
        selectedFeeds,
        setSelectedFeeds,
        duration,
        setDuration,
        selectedValues,
        setSelectedValues,
        layoutType,
        setLayoutType,
        playbackRate,
        setPlaybackRate,
        sync,
        setSync,
      }}
    >
      {children}
    </PlaybackContext.Provider>
  );
};
